import { ACTIONS } from '_redux/actions';
import { get } from './api';

export function fetchLeaderboard(params) {
  return get('leaderboard',
    params,
    ACTIONS.LEADERBOARD.FETCH_ENTRIES,
    ACTIONS.LEADERBOARD.FETCH_ENTRIES_SUCCESS,
    ACTIONS.LEADERBOARD.FETCH_ENTRIES_ERROR,
    false);
}


export function openLeaderboard() {
  return {
    type: ACTIONS.LEADERBOARD.OPEN,
  };
}

export function closeLeaderboard() {
  return {
    type: ACTIONS.LEADERBOARD.CLOSE,
  };
}

export function toggleLeaderboard(isOpen) {
  if (isOpen) {
    return closeLeaderboard();
  }

  return openLeaderboard();
}
